import { EDITABLE_FIELDS, toFormValues, toParams } from './fields';

describe('management/EditUser fields', () => {
  describe('toFormValues', () => {
    it('keeps the editable fields', () => {
      const values = toFormValues({ firstName: 'Abe', lastName: 'Martinez' });

      expect(values.firstName).toBe('Abe');
      expect(values.lastName).toBe('Martinez');
    });

    // Username is displayed but not editable, so it is not part of the form's state.
    it('leaves out anything not editable', () => {
      const values = toFormValues({ username: 'm.abe', id: 7 });

      expect(values).not.toHaveProperty('username');
      expect(values).not.toHaveProperty('id');
    });

    // An input handed null flips between controlled and uncontrolled, which React
    // warns about and which loses the user's cursor.
    it('turns a missing value into an empty string', () => {
      const values = toFormValues({ firstName: null, phone: undefined });

      expect(values.firstName).toBe('');
      expect(values.phone).toBe('');
    });

    it('stringifies a numeric country code', () => {
      expect(toFormValues({ mobileCountryCode: 1 }).mobileCountryCode).toBe(
        '1',
      );
    });

    it('covers every editable field, so no input is left uncontrolled', () => {
      const values = toFormValues({});

      // Plus ssoProvider, which the form holds but does not send inside `user` —
      // it is not a column on users (PD-4684).
      expect(Object.keys(values).sort()).toEqual(
        [...Object.keys(EDITABLE_FIELDS), 'ssoProvider'].sort(),
      );
    });

    it('reads the Authentication value from the assignment, not a column', () => {
      expect(
        toFormValues({ authentication: { provider: 'paccar' } }),
      ).toMatchObject({ ssoProvider: 'paccar' });
    });

    it('treats a user with no identity provider as a password user', () => {
      expect(
        toFormValues({ authentication: { provider: null } }),
      ).toMatchObject({
        ssoProvider: 'password',
      });
    });
  });

  describe('toParams', () => {
    it('renames each field to the parameter the controller permits', () => {
      const params = toParams(
        toFormValues({ firstName: 'Abe', jobRole: '987' }),
      );

      expect(params.first_name).toBe('Abe');
      expect(params.job_role).toBe('987');
    });

    it('sends no key the controller does not permit', () => {
      const params = toParams(toFormValues({ username: 'm.abe' }));

      expect(params).not.toHaveProperty('username');
      expect(Object.keys(params).sort()).toEqual(
        Object.values(EDITABLE_FIELDS).sort(),
      );
    });
  });
});
